import { faHandHoldingDollar, faLocationDot, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { use } from 'react'
import "./UserInfo.css";

const UserInfo = ({ user, address, payment }) => {
    console.log(user, address, 'user, address');

    return (
        <section className="UserInfo">
            <div className='main_profile_container'>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faUser} className="icon" />
                    </div>
                    <div className='text_holder'>
                        <p className='username'>{user?.name + " " + user?.last_name}</p>
                        <p className='contact'>+{user?.contact_no}</p>
                    </div>
                </div>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faLocationDot} className="icon" />
                    </div>
                    <div className='text_holder'>
                        <p className='address'>{address?.floor + ", " + address?.apartment + ", " + address?.building + ", " + address?.direction}</p>
                    </div>
                </div>

                <div className='icon_text_holder'>
                    <div className='icon_holder'>
                        <FontAwesomeIcon icon={faHandHoldingDollar} className='icon' />
                    </div>
                    <div className='text_holder'>
                        <p className='pay'>{payment?.name}</p>
                    </div>
                </div>
            </div>



        </section>
    )
}

export default UserInfo
